import axios from "../../utils/axios";

export const getTotalBalance = async () => {
  const response = await axios.get("/transactions");
  const balance = response.data.reduce((prevBalance, currentObj) => {
    if (currentObj.type === "income")
      return (prevBalance += parseInt(currentObj.amount));
    else return (prevBalance -= parseInt(currentObj.amount));
  }, 0);
  return balance;
};
